module.exports = __webpack_public_path__ + "assets/img/modal-tab-fb7c1880.png";